import {isEqual} from 'lodash';
import saveTrack from '../../../utils/gaia/saveTrack';
import {AddSavePromise} from '../../useIsSaved';
import {formatCoordinates, isFormattedCoordinates} from '../../../utils/formatters';

interface UpdatePointOptions {
    action: UpdateTrackPointAction;
    tracks: {[trackLocalId: string]: Track};
    setTracks: React.Dispatch<React.SetStateAction<{[trackLocalId: string]: Track}>>;
    project: MapProject;
    addSavePromise: AddSavePromise;
}

export default function updatePoint({
    action,
    tracks,
    setTracks,
    project,
    addSavePromise
}: UpdatePointOptions) {

    const {point} = action;
    const {trackLocalId, pointLocalId} = point.properties;
    const prevTrack = tracks[trackLocalId];
    if (!prevTrack.isGeometryLoaded) return pointLocalId;
    const prevPoint = prevTrack.points[pointLocalId];

    const isGeometryModified = !isEqual(point.geometry, prevPoint.geometry);

    const nextTrack = {
        ...prevTrack,
        points: {
            ...prevTrack.points,
            [pointLocalId]: {
                ...point,
                properties: {
                    ...point.properties,
                    unsnappedCoordinates: undefined,
                    isGeometryModified: (
                        prevPoint.properties.isGeometryModified ||
                        isGeometryModified
                    ),
                    title: isGeometryModified && isFormattedCoordinates(point.properties.title) ?
                        formatCoordinates(point.geometry.coordinates) :
                        point.properties.title
                }
            }
        }
    };

    if (!isEqual(nextTrack, prevTrack)) setTracks({...tracks, [trackLocalId]: nextTrack});
    if (action.save === true) saveTrack(nextTrack, project, addSavePromise);

    return pointLocalId;
}
